import $ from 'jquery';
import BaseClass from '../../libs/base/BaseClass';
import InputValidationClass from './InputValidationClass';
import Util from '../../libs/util/Util';

/**
 * バリデーション 管理
 */
export default class InputValidationManagerClass extends BaseClass {
  constructor(_target, _errorInsertTarget) {
    super();
    this.name = 'InputValidationManagerClass';

    this.EVENT_CLEAR = 'eventClear';
    // エラーメッセージを削除したくないの場合 => false
    this.errorClearFlg = true;
    this.target = _target;
    this.errorInsertTarget = _errorInsertTarget;
    this.error = null;
    // function return {result(NG->true,OK->false),text(errorMessage)}
    this.relationCheckObj = null;
    this.onSubmitListener = this.onSubmit.bind(this);
    // mixFlg = trueの時、複数の_targetで、最後のformのsubmitイベントを実施
    this.mixFlg = false;
  }

  onCreate() {
    super.onCreate();

    const self = this;

    this.items = [];
    $('[data-validation]', this.target).each((index, element) => {
      self.items.push(new InputValidationClass($(element)));
    });

    for (let k in this.items) {
      this.items[k].onCreate();
      this.items[k].on(this.items[k].EVENT_CHANGE, () => {
        this.onCheck(false);
      });
    }

    this.error = this.errorInsertTarget.prev('.submit_error');

    if (this.target.length > 1 && this.mixFlg) {
      $(this.target.get(this.target.length - 1)).on('submit', this.onSubmitListener);
    } else {
      this.target.on('submit', this.onSubmitListener);
    }

  }

  onSubmit(e) {
    // console.log(this.name, 'onSubmit');
    if (this.onCheck(true)) {
      e.preventDefault();


    } else {

      // 同姓同名の予約チェック
      let match = document.getElementById('travelko');
      if(match !== null) {
        let persons = [];
        $('.input_person,#nm,#ap').filter(function () {
          let person = {
            seikana: $(this).find('input[id*=seikana]').val(),
            meikana: $(this).find('input[id*=meikana]').val(),
            seiroma: $(this).find('input[id*=seiroma]').val(),
            meiroma: $(this).find('input[id*=meiroma]').val(),
            gender: $(this).find('input[name*=gender]:checked').val(),
            birthdayY: $(this).find('select[id*=birthdayY]').val(),
            birthdayM: $(this).find('select[id*=birthdayM]').val(),
            birthdayD: $(this).find('select[id*=birthdayD]').val(),
          };
          let adult1 = $(this).find('input[id=adult1]').val();
          let adlpax1eqapplicant = $("input[name='adlpax1eqapplicant']:checked").val();

          // 搭乗者1ではない場合
          if( adult1 !== 'true'){
            if (!!person.seikana || !!person.meikana || !!person.seiroma || !!person.meiroma) {
              if (this.id =='nm' || this.id =='ap') {
                // 申込者
                persons.push({person:JSON.stringify(person),throughFlg:1});
              } else {
                persons.push({person:JSON.stringify(person),throughFlg:0});
              }
            }
          } else {
            if(adlpax1eqapplicant == 'N'){
              if (!!person.seikana || !!person.meikana || !!person.seiroma || !!person.meiroma) {
                // 搭乗者1
                persons.push({person:JSON.stringify(person),throughFlg:1});
              }
            }
          }

        });

        let nary = persons.sort((a, b) => {
          //personの昇順
          if(a.person > b.person) return 1;
          if(a.person < b.person) return -1;
          //throughFlgの昇順
          if(a.throughFlg > b.throughFlg) return 1;
          if(a.throughFlg < b.throughFlg) return -1;
          return 0;
        });

        console.log(nary)
        for (let i = 0; i < nary.length - 1; i++) {
          // 姓名等が同一の場合はダイアログを出す。
          if (nary[i]['person'] === nary[i + 1]['person']) {
            // 申込者と搭乗者が異なる場合で申込者と搭乗者１の入力が同じ場合はダイヤログを出さない。
            if( nary[i]['throughFlg'] == 1 && (nary[i]['throughFlg'] == nary[i + 1]['throughFlg']) ){
              continue;
            }

            console.log("重複内容：" + nary[i]);
            if (confirm('姓名等が同一の搭乗者が入力されています。\n' +
              'よろしいでしょうか？\n')) {

            } else {
              e.preventDefault();
            }

            return;
          }
        }
      }

      this.jq.trigger(this.EVENT_CLEAR, { event: e });
    }

  }

  onCheck(_isAddError) {
    let isError = false;
    let text = '';
    const errors = [];
    for (let k in this.items) {
      let res = this.items[k].onCheck(_isAddError);
      if (res.result && !isError) { isError = res.result; }
      if (res.result) {
        if (text !== '') { text += '、'; }
        text += res.text;
        errors.push(res);
      }
    }
    // 相関チェック
    let relationCheckError = false;
    if (this.relationCheckObj !== null && !isError) {
      let res = this.relationCheckObj.relationCheck.apply(this.relationCheckObj);
      if (res.result) {
        isError = true;
        relationCheckError = true;
        text = res.text;
        if (!res.parent) {
          res.parent = this.target;
        }
        errors.push(res);
      }
    }

    if (isError) {
      if (_isAddError) {
        if (relationCheckError) {
          this.errorAdd(errors[0].text);
        } else {
          this.errorAdd(LtikeCommon.TEXT.ERROR_INPUT_VALIDATION);
        }
        Util.runScroll(errors[0].parent);
      }
    } else {
      this.errorClear();
    }

    return isError;
  }

  errorAdd(_text) {
    if (!this.error || this.error.length <= 0) {
      if (this.error.length < 1) {
        this.error = $('<div class="submit_error"><p></p></div>').insertBefore(this.errorInsertTarget);
      }
    }
    this.error.show();
    $('p', this.error).html(_text);
  }

  errorClear() {
    if (this.error && this.errorClearFlg) {
      $('p', this.error).html('');
      this.error.hide();
    }
  }

  setRelationCheck(obj) {
    if (obj && typeof obj.relationCheck === 'function') {
      this.relationCheckObj = obj;
    }
  }

}
